import { render, staticRenderFns } from "./NewExpenseDefinitionAdd.vue?vue&type=template&id=68b8ad48&scoped=true"
import script from "./NewExpenseDefinitionAdd.vue?vue&type=script&lang=js"
export * from "./NewExpenseDefinitionAdd.vue?vue&type=script&lang=js"
import style0 from "./NewExpenseDefinitionAdd.vue?vue&type=style&index=0&id=68b8ad48&prod&lang=scss&scoped=true"
import style1 from "./NewExpenseDefinitionAdd.vue?vue&type=style&index=1&id=68b8ad48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b8ad48",
  null
  
)

export default component.exports